import TrusteesCards from '../components/TrusteesCards';
import styles from './TrusteesInfo.module.css';

export default function TrusteesInfo() {
    return (
        <section className={styles.TrusteesInfo} id='trustees-info'>
          <h2 className={styles.PageName}>our trusted board members</h2>
           <TrusteesCards />
        </section>
    )
}